package com.taocent.simple.compose.component.richtext.core.internal.dialog

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.taocent.simple.compose.component.richtext.core.internal.format.RichTextFormatState

@Composable
fun LinkDialog(
    state: RichTextFormatState,
    restoreSelection: () -> Unit,
    onDismiss: () -> Unit,
    onConfirm: () -> Unit
) {
    var linkDisplayText by remember { mutableStateOf("") }
    var linkUrl by remember { mutableStateOf("") }

    // 注意:**不再**在 onDismiss / onConfirm / dismissButton 中调 `LocalFocusManager.clearFocus()`。
    //
    // 原行为:AlertDialog 关闭时主动清空整个焦点栈(包含文本块/单元格的 RichTextTextField)。
    // 问题(2026-06-14 用户反馈):
    //   - Android / iOS / Web 移动端:软键盘本就未展开时,关闭 dialog 后焦点不恢复,文本块光标丢失
    //   - Web mobile webview:软键盘本就未展开时,关闭 dialog 后 IME 焦点丢失
    //
    // 新行为:AlertDialog 关闭时由平台/Compose 自动把焦点还给原 focus owner,
    // 顶层 [BlockRichTextEditor] 的 `LaunchedEffect(showLinkDialog)` 会基于
    // `state.hasUserFocusedAnyField` 判断是否需要再次 requestFocus(并按需 show 键盘)。
    AlertDialog(
        onDismissRequest = {
            onDismiss()
        },
        title = { Text("插入超链接") },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                OutlinedTextField(
                    value = linkDisplayText,
                    onValueChange = { linkDisplayText = it },
                    label = { Text("显示文本") },
                    singleLine = true,
                    modifier = Modifier.fillMaxWidth()
                )
                OutlinedTextField(
                    value = linkUrl,
                    onValueChange = { linkUrl = it },
                    label = { Text("链接地址 (URL)") },
                    singleLine = true,
                    modifier = Modifier.fillMaxWidth()
                )
            }
        },
        confirmButton = {
            TextButton(
                onClick = {
                    if (linkDisplayText.isNotEmpty()) {
                        restoreSelection()
                        state.insertHyperlink(linkDisplayText, linkUrl)
                        onConfirm()
                    }
                }
            ) { Text("确定") }
        },
        dismissButton = {
            TextButton(
                onClick = {
                    onDismiss()
                }
            ) { Text("取消") }
        }
    )
}
